import React from 'react'

import { useSurveyForSettingsQueryData } from './useSurveyForSettingsQueryData'

export const useSurveyForSettingsQueryQuestions = () => {
  const survey = useSurveyForSettingsQueryData()

  return React.useMemo(() => survey?.questions ?? [], [survey?.questions])
}
